import React from 'react';

import styles from '~/components/entity-search/entity-search-supporting-details-item/entity-search-supporting-details-item.module.scss';

interface Props {
	label: string | undefined;
	value: string | undefined;
	description?: string;
}

export class EntitySearchSupportingDetailsItem extends React.Component<Props> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { children } = this.props;
		const value = this.props.value ? this.props.value.trim() : '';
		if (value === '') {
			// Hide items without a value set
			return null;
		}
		const label = this.props.label ? this.props.label.trim() : '';
		const description = this.props.description
			? this.props.description.trim()
			: '';

		// Compute title
		let title: string = value;
		if (description) {
			title += ' (' + description + ')';
		}

		return (
			<li title={title} className={styles.item}>
				<strong className={styles.label}>{label}</strong>
				<span className={styles.value}>
					<span>{value}</span>
					<span className={styles.description}>
						{description ? ' (' + description + ')' : ''}
					</span>
				</span>
				{children}
			</li>
		);
	}
}
